module.exports = __webpack_public_path__ + "img/kgold-new.7e8ae4e.png";